export const modalAction = {
	OPEN: 0,
	CLOSE: 1,
};

export const modalInitialState = {
	show: false,
	data: {},
};

export const modalReducer = (state, action) => {
	switch (action.type) {
		case modalAction.OPEN:
			return { ...state, show: true, data: action.payload };

		case modalAction.CLOSE:
			return modalInitialState;

		default:
			throw new Error(
				"Invalid action at course purchase record modal reducer"
			);
	}
};
